import { render, staticRenderFns } from "./RestoreAccountTabs.vue?vue&type=template&id=5d307125&"
import script from "./RestoreAccountTabs.vue?vue&type=script&lang=js&"
export * from "./RestoreAccountTabs.vue?vue&type=script&lang=js&"
import style0 from "./RestoreAccountTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports